import * as tslib_1 from "tslib";
import { Component, Watch } from 'vue-property-decorator';
import DataTable from '@/components/DataTable/DataTable.vue';
import { IDataTableHeaderType } from '@/components/DataTable/interfaces/IDataTableHeader';
import JSPage from '@/classes/JSPage';
import InputField from '@/components/InputField/InputField.vue';
import moment from 'moment';
import BaseService from '@/services/BaseService';
import ArticleService from '@/services/ArticleService';
import CategoryService from '@/services/CategoryService';
import { ForeignEntry } from '@/models/ForeignEntry';
import MaterialCard from '@/components/Base/MaterialCard/MaterialCard.vue';
import Router from '@/classes/Router';
let AvailabilityPage = class AvailabilityPage extends JSPage {
    constructor() {
        super(...arguments);
        this.headers = [];
        this.data = { data: [] };
        this.mode = 'article';
        this.on_date = moment().subtract(1, 'month').toDate();
        this.last_on_date = moment().toDate();
        this.article = new ForeignEntry();
        this.category = new ForeignEntry();
        this.articles = new Array();
        this.categories = new Array();
    }
    onDataChanged() {
        if (!(this.article instanceof ForeignEntry)) {
            this.article = new ForeignEntry(this.article);
        }
        if (!(this.category instanceof ForeignEntry)) {
            this.category = new ForeignEntry(this.category);
        }
        const hasDates = this.on_date && this.last_on_date;
        const articleReady = this.mode === 'article' && (this.article instanceof ForeignEntry) && Number(this.article.value) > 0;
        const categoryReady = this.mode === 'category' && (this.category instanceof ForeignEntry) && Number(this.category.value) > 0;
        const allReady = this.mode === 'all';
        this.setHeaders();
        // Always sync mode to URL and clear stale data when conditions aren't met
        Router.addQueryToURL('mode', this.mode);
        if (!hasDates || (!articleReady && !categoryReady && !allReady)) {
            this.data = { data: [] };
            return;
        }
        this.data = { data: [] }; // clear stale data while loading
        const payload = {
            from: moment(this.on_date).format('YYYY-MM-DD'),
            to: moment(this.last_on_date).format('YYYY-MM-DD')
        };
        Router.addQueryToURL('from', payload.from);
        Router.addQueryToURL('to', payload.to);
        if (this.mode === 'article') {
            payload.id_article = this.article;
            Router.addQueryToURL('a', this.article.value);
        }
        else if (this.mode === 'category') {
            payload.id_category = this.category.value;
            Router.addQueryToURL('c', this.category.value);
        }
        BaseService.post('stats/availability', payload, true).subscribe((data) => {
            this.data = data;
        });
    }
    created() {
        super.created();
        this.mode = Router.getQueryVar('mode', 'article');
        this.on_date = moment(Router.getQueryVar('from', moment(this.on_date).format('YYYY-MM-DD'))).toDate();
        this.last_on_date = moment(Router.getQueryVar('to', moment(this.last_on_date).format('YYYY-MM-DD'))).toDate();
        const articleId = parseInt(Router.getQueryVar('a', -1));
        const categoryId = parseInt(Router.getQueryVar('c', -1));
        (new ArticleService()).getAll(undefined, 'name=ASC', 1, 9999).subscribe((articlesData) => {
            this.articles = articlesData.data.map(a => {
                const label = a.code ? `${a.code} - ${a.name}` : String(a.name);
                const entry = new ForeignEntry(a.id, label);
                entry.searchText = [a.code, a.name].filter(Boolean).join(' ').toUpperCase();
                return entry;
            });
            this.article = this.articles.find(a => a.value === articleId) || new ForeignEntry();
        });
        (new CategoryService()).getAll(undefined, 'name=ASC', 1, 9999).subscribe((categoriesData) => {
            this.categories = categoriesData.data.map(c => new ForeignEntry(c.id, c.name));
            this.category = this.categories.find(c => c.value === categoryId) || new ForeignEntry();
            this.onDataChanged();
        });
    }
    main() {
        this.setHeaders();
    }
    setHeaders() {
        if (this.mode === 'article') {
            this.headers = [
                { text: 'Reserva', value: 'id_book.strValue', align: 'start', sortable: false },
                { text: 'Cliente', value: 'id_customer.strValue', align: 'start', sortable: false },
                { text: 'Emplazamiento', value: 'id_site.strValue', align: 'start', sortable: false },
                { text: 'Inicio', value: 'start_date', align: 'center', type: IDataTableHeaderType.DATE, sortable: false },
                { text: 'Fin', value: 'end_date', align: 'center', type: IDataTableHeaderType.DATE, sortable: false },
                { text: 'Cantidad', value: 'quantity', align: 'center', sortable: false },
                { text: '', value: 'actions', align: 'end', sortable: false }
            ];
        }
        else {
            this.headers = [
                { text: 'Categoría', value: 'id_category.strValue', align: 'start', sortable: false },
                { text: 'Código', value: 'code', align: 'start', sortable: false },
                { text: 'Artículo', value: 'id_article.strValue', align: 'start', sortable: false },
                { text: 'Stock', value: 'stock', align: 'center', sortable: false },
                { text: 'Reservado', value: 'total', align: 'center', sortable: false },
                { text: 'Disponible', value: 'available', align: 'center', sortable: false },
                { text: '', value: 'actions', align: 'end', sortable: false }
            ];
        }
    }
    articleFilterMethod(query, items) {
        if (!query || !query.trim())
            return items;
        const words = query.trim().toUpperCase().split(/\s+/);
        return items.filter(item => {
            const text = item.searchText || item.strValue.toUpperCase();
            return words.every(word => text.includes(word));
        });
    }
    onItemSelected(item) {
        if (this.mode === 'article') {
            Router.goTo('books/' + item.id_book.value + '#sites-tab');
        }
        else {
            const found = this.articles.find(a => a.value === item.id_article.value);
            if (found) {
                this.article = found;
            }
            this.mode = 'article';
        }
    }
    get articleRequired() {
        return this.mode === 'article' && this.article && ((this.article instanceof ForeignEntry) ? Number(this.article.value) > 0 : this.article > 0);
    }
    get printPostTitle() {
        const from = moment(this.on_date).format('DD/MM/YYYY');
        const to = moment(this.last_on_date).format('DD/MM/YYYY');
        let label = '';
        if (this.mode === 'article') {
            const id = (this.article instanceof ForeignEntry) ? this.article.value : this.article;
            const art = this.articles.find(a => a.value === id);
            if (!art || !(Number(art.value) > 0))
                return '';
            label = `<strong>Artículo: </strong>${art.strValue}`;
        }
        else if (this.mode === 'category') {
            const cat = this.categories.find(c => c.value === this.category.value);
            if (!cat)
                return '';
            label = `<strong>Categoría: </strong>${cat.strValue}`;
        }
        else {
            label = '<strong>Todos los artículos</strong>';
        }
        return `
        <div style='font-size:12px;border:1px solid #999;background-color: #eee;padding:4px;width:99%;margin:0px auto 12px auto;'>
            <div>${label}</div>
            <div><strong>Desde el </strong>${from} <strong>al</strong> ${to}</div>
        </div>
        ${this.mode === 'article' && this.data && this.data.data ? `
        <div style='display:flex;width:99%;margin:0 auto 12px auto;border:1px solid #ccc;font-size:13px;'>
            <div style='flex:1;text-align:center;padding-top:4px;border-right:1px solid #ccc;background:#eee;'>
                <div style='color:#666;line-height:13px;'>Total instalados</div>
                <div style='font-weight:500;font-size:15px;'>${this.data.total}</div>
            </div>
            <div style='flex:1;text-align:center;padding-top:4px;border-right:1px solid #ccc;background:#eee;'>
                <div style='color:#666;line-height:13px;'>Stock</div>
                <div style='font-weight:500;font-size:15px;'>${this.data.stock}</div>
            </div>
            <div style='flex:1;text-align:center;padding-top:4px;background:#eee;'>
                <div style='color:#666;line-height:13px;'>Disponible</div>
                <div style='font-weight:500;font-size:15px;'>${this.data.available}</div>
            </div>
        </div>` : ''}
        `;
    }
};
tslib_1.__decorate([
    Watch('on_date'),
    Watch('last_on_date'),
    Watch('article'),
    Watch('category'),
    Watch('mode')
], AvailabilityPage.prototype, "onDataChanged", null);
AvailabilityPage = tslib_1.__decorate([
    Component({
        components: {
            DataTable, InputField, MaterialCard
        }
    })
], AvailabilityPage);
export default AvailabilityPage;
